import React from 'react';

export const SidebarIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.5 1.5V16.5M5.5 1.5H12.5C13.9002 1.5 14.6002 1.5 15.135 1.77248C15.6054 2.01217 15.9878 2.39462 16.2275 2.86503C16.5 3.3998 16.5 4.09987 16.5 5.5V12.5C16.5 13.9002 16.5 14.6002 16.2275 15.135C15.9878 15.6054 15.6054 15.9878 15.135 16.2275C14.6002 16.5 13.9002 16.5 12.5 16.5H5.5C4.09987 16.5 3.3998 16.5 2.86503 16.2275C2.39462 15.9878 2.01217 15.6054 1.77248 15.135C1.5 14.6002 1.5 13.9002 1.5 12.5V5.5C1.5 4.09987 1.5 3.3998 1.77248 2.86503C2.01217 2.39462 2.39462 2.01217 2.86503 1.77248C3.3998 1.5 4.09987 1.5 5.5 1.5Z"
      stroke=""
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
